/**
 * skipNavigation
 * @class
 * @constructor
 * @public
 */
class skipNavigation {
  /**
   * Constructor
   * @returns {class}
   */
  constructor() {
    this.element = document.querySelector(".skip-navigation");

    if (this.element) {
      // Engage engines
      this.init();
    }
  }

  /**
   * Initialize the skip navigation element
   * @returns {void}
   */
  init() {
    const links = this.element.querySelectorAll(".skip-navigation-btn");

    if (!links.length) return;

    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        const targetId = link.getAttribute("href").replace("#", "");
        const targetElement = document.getElementById(targetId);
        if (!targetElement) return;

        e.preventDefault();
        targetElement.tabIndex = -1;
        targetElement.focus();
      });
    });
  }

  /**
   * Class name
   * @returns {string} The human readable class name
   */
  get name() {
    return "skipNavigation";
  }
}

export default skipNavigation;
